import { createFileRoute } from "@tanstack/react-router";
import Page from "@/app/employee/[id]/dearest/page";

export const Route = createFileRoute("/employee/$id/dearest/")({
  component: Page,
});
